/**
 * `AgentCardEditorDrawer` — right-side drawer that mounts the agent-card
 * field-editor + the LLM `SuggestionsModal` apply flow (2026-10-01).
 *
 * The editor reuses the existing `Visibility` component as its body so
 * there is no duplicated field-list / typed-apply-route / no-auto-apply
 * logic (ADR-0114's no-auto-apply invariant is preserved: a merchant
 * click through the typed route is still the write authority).
 *
 * A follow-up slice will extract just the field-list + modal from
 * `Visibility` so this drawer stops carrying the view's score +
 * header chrome; the current wiring is intentionally thin so the
 * readiness page's "Edit card" button lands the merchant on the real
 * writable surface instead of jumping to a different route.
 */

import { Drawer } from '../../components/atoms/Drawer.js';
import type { SetView } from '../../app/view-router.js';
import { Visibility } from '../visibility/Visibility.js';

export interface AgentCardEditorDrawerProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly setView: SetView;
  /** When set, the embedded editor auto-opens the per-field modal for
   *  this field so the merchant lands on exactly the row they clicked
   *  on in the Agent Readiness page. */
  readonly focusFieldId?: string | null;
}

export function AgentCardEditorDrawer({ open, onClose, setView, focusFieldId = null }: AgentCardEditorDrawerProps): JSX.Element | null {
  if (!open) return null;
  return (
    <Drawer open={open} onClose={onClose} title="AGENT CARD · EDITOR" data-testid="readiness-agent-card-drawer">
      <div className="p-2 sm:p-4">
        <Visibility goTo={setView} embedded focusFieldId={focusFieldId} />
      </div>
    </Drawer>
  );
}
